/* Keeps one included liner pack per Grassifier in the cart (AU only).

   Every Grassifier ships with a 10-pack of porous liners. The "Liner pack
   included" automatic discount makes one pack free per Grassifier, but only if
   the pack is actually in the cart - and the product page picker used to add a
   single pack whatever the quantity, while quick-add and cart quantity changes
   added none at all.

   So after anything changes the cart, keep at least one pack per Grassifier,
   and when Grassifiers are removed, remove the same number of packs. Spares
   bought on purpose ride along: 3 potties plus 1 spare is 4 packs, and dropping
   to 1 potty leaves 2.

   No cost on ordinary page loads: it only fetches /cart.js on the cart page and
   after the theme reports a cart change. */
(function () {
  'use strict';
  var GRASSIFIER = 'grassifier';
  var LINER = 'liner-pack';
  var KEY = 'rgppLinerSyncG';
  var busy = false;

  function store(get, val) {
    try {
      if (get) return sessionStorage.getItem(KEY);
      sessionStorage.setItem(KEY, String(val));
    } catch (e) { return null; }
  }

  function json(url, body) {
    return fetch(url, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  function sync() {
    if (busy) return;
    busy = true;
    json('/cart.js').then(function (cart) {
      if (cart.currency && cart.currency !== 'AUD') return false;

      var g = 0, l = 0, linerLines = [], linerVariant = null;
      cart.items.forEach(function (it) {
        if (it.handle === GRASSIFIER) g += it.quantity;
        if (it.handle === LINER) { l += it.quantity; linerLines.push(it); linerVariant = it.variant_id; }
      });

      /* Up: top the packs up to one per Grassifier (the product page already
         adds them, so this only fills gaps - quick-add, cart quantity +).
         Down: take off as many packs as Grassifiers were removed, but only
         from the surplus, so spares bought on purpose stay. */
      var prev = parseInt(store(true), 10);
      var target = Math.max(l, g);
      if (!isNaN(prev) && g < prev) {
        target = l - Math.min(prev - g, Math.max(0, l - g));
      }
      store(false, g);

      if (target === l) return false;

      if (target > l) {
        if (!linerVariant) {
          var picker = document.querySelector('[data-rgpp-liner-variant]');
          linerVariant = picker ? parseInt(picker.getAttribute('data-rgpp-liner-variant'), 10) : null;
        }
        if (!linerVariant) {
          /* no liner line to copy the variant from - look it up */
          return json('/products/' + LINER + '.js').then(function (p) {
            return json('/cart/add.js', { items: [{ id: p.variants[0].id, quantity: target - l }] });
          }).then(function () { return true; });
        }
        return json('/cart/add.js', { items: [{ id: linerVariant, quantity: target - l }] }).then(function () { return true; });
      }

      /* Fewer: take packs off the last liner line first (paid spares sit after
         the free line), one line at a time. */
      var remove = l - target;
      var chain = Promise.resolve();
      for (var i = linerLines.length - 1; i >= 0 && remove > 0; i--) {
        (function (line) {
          var take = Math.min(remove, line.quantity);
          remove -= take;
          chain = chain.then(function () {
            return json('/cart/change.js', { id: line.key, quantity: line.quantity - take });
          });
        })(linerLines[i]);
      }
      return chain.then(function () { return true; });
    }).then(function (changed) {
      if (!changed) return;
      if (/^\/cart\/?$/.test(location.pathname)) {
        location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }
    }).catch(function () { /* a refused add (liner sold out) must never block the sale */ })
      .then(function () { busy = false; });
  }

  ['theme:cart:change', 'theme:cart:add'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(sync, 400); });
  });

  if (/^\/cart\/?$/.test(location.pathname)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  }
})();
